<template>
  <el-dialog
    top="80px"
    title="Danh sách các dịch vụ nổi bật"
    class="services-popup"
    width="780px"
    :visible="visible"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <div class="services-popup__content">
      <div v-if="!serviceGroups.length" class="empty">
        <p>Hiện tại chưa có thông tin các dịch vụ tiện ích</p>
        <p>Vui lòng tạo thêm thông tin.</p>
      </div>
      <div v-else class="service-content">
        <div
          v-for="group in serviceGroups"
          :key="group.id || group.slug"
          class="service-group"
        >
          <h3 class="group-title">{{ group.name }}</h3>
          <el-row :gutter="16" class="service-cards-row">
            <el-col
              v-for="service in group.services"
              :key="service.id"
              :xs="12"
              :sm="8"
              :md="6"
              class="mb-3"
            >
              <el-card class="service-card" shadow="hover">
                <img :src="service.avatar_url" alt="" />
                <p class="service-name mb-0" :title="service.name">
                  <b>{{ service.name }}</b>
                </p>
                <el-checkbox
                  v-model="service.checked"
                  size="medium"
                  class="service-checkbox"
                  @change="handleCheckboxChange"
                ></el-checkbox>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <el-row slot="footer" class="footer pt-3" type="flex" justify="space-between" align="center">
      <el-checkbox v-model="selectAll" size="medium" @change="handleSelectAll">Chọn tất cả</el-checkbox>
      <el-button type="primary" @click="handleCompleted">Hoàn tất</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getTranslation } from '@/utils/filters'

function getServiceGroupId(service) {
  if (!service) return null
  if (service.group && typeof service.group === 'object') {
    return service.group.slug || service.group.id
  }
  return (
    service.group_slug ||
    service.group ||
    service.group_id ||
    service.place_service_group_id ||
    service.service_group_id ||
    service.place_facility_group_id ||
    service.facility_group_id ||
    service.parent_id ||
    null
  )
}

export default {
  name: 'ServicesPopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    services: {
      type: Array,
      default: () => []
    },
    selectedServices: {
      type: Array,
      default: () => []
    },
    placeType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      serviceGroups: [],
      selectAll: false
    }
  },
  computed: {
    ...mapGetters(['constant', 'language']),
    currentPlaceType() {
      return (
        this.placeType ||
        (this.$route && this.$route.meta && this.$route.meta.data && this.$route.meta.data.type) ||
        (this.$route && this.$route.query && this.$route.query.place_type) ||
        ''
      )
    },
    serviceGroupsFromConstant() {
      const constants = (this.constant && this.constant.constants) || {}
      const groups =
        constants.place_service_groups ||
        constants.service_groups ||
        constants.place_facility_groups ||
        constants.facility_groups ||
        constants.facilityGroups ||
        []
      return groups.map((g) => ({
        ...g,
        name: (getTranslation(g, this.language) && getTranslation(g, this.language).name) || g.name
      }))
    },
    service_ids() {
      let ids = []
      this.serviceGroups.forEach((g) => {
        ids = [...ids, ...g.services.filter((s) => s.checked).map((s) => s.id)]
      })
      return ids
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.buildServiceGroups()
      }
    },
    services: {
      deep: true,
      handler() {
        if (this.visible) {
          this.buildServiceGroups()
        }
      }
    },
    selectedServices: {
      deep: true,
      handler() {
        if (this.visible) {
          this.buildServiceGroups()
        }
      }
    },
    currentPlaceType() {
      if (this.visible) {
        this.buildServiceGroups()
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.buildServiceGroups()
    }
  },
  methods: {
    buildServiceGroups() {
      const targetType = this.currentPlaceType
      const rawServices =
        this.services && this.services.length > 0
          ? this.services
          : (this.constant &&
              this.constant.constants &&
              this.constant.constants.place_services) ||
            []

      const filtered = targetType
        ? rawServices.filter((s) => !s.place_type || s.place_type === targetType)
        : rawServices

      const services = filtered.map((s) => ({
        ...s,
        name:
          (getTranslation(s, this.language) &&
            getTranslation(s, this.language).name) ||
          s.name,
        checked: this.selectedServices ? this.selectedServices.includes(s.id) : false
      }))

      // 2. Group theo groups (lấy trong constants)
      const matchedServiceIds = new Set()
      const result = []

      this.serviceGroupsFromConstant.forEach((group) => {
        const groupItems = services.filter((s) => {
          const gId = getServiceGroupId(s)
          return (
            gId &&
            ((group.slug && (gId === group.slug || String(gId) === String(group.slug))) ||
              (group.id && (gId === group.id || String(gId) === String(group.id))))
          )
        })

        if (groupItems.length > 0) {
          groupItems.forEach((s) => matchedServiceIds.add(s.id))
          result.push({
            ...group,
            services: groupItems
          })
        }
      })

      // Group các dịch vụ không thuộc nhóm nào hoặc nhóm không có trong constants
      const ungrouped = services.filter((s) => !matchedServiceIds.has(s.id))
      if (ungrouped.length > 0) {
        result.push({
          id: 'ungrouped',
          name: 'Dịch vụ khác',
          services: ungrouped
        })
      }

      this.serviceGroups = result
      this.updateSelectAllState()
    },
    handleSelectAll(val) {
      this.serviceGroups.forEach((g) => {
        g.services.forEach((s) => {
          s.checked = val
        })
      })
    },
    handleCheckboxChange() {
      this.updateSelectAllState()
    },
    updateSelectAllState() {
      const all = this.serviceGroups.flatMap((g) => g.services)
      this.selectAll = all.length > 0 && all.every((s) => s.checked)
    },
    handleCompleted() {
      this.$emit('update', this.service_ids)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.services-popup {
  .footer {
    border-top: 1px solid #f5f5f5;
  }
  &__content {
    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px 0;
      text-align: center;
      color: #909399;
    }
    .service-group {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .group-title {
      font-size: 15px;
      font-weight: 600;
      margin: 0 0 12px 0;
      color: #303133;
      padding-bottom: 8px;
      border-bottom: 1px solid #ebeef5;
    }
    .service-card {
      text-align: center;
      position: relative;
      height: 100%;
      img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        margin-bottom: 8px;
      }
      .service-name {
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .service-checkbox {
        position: absolute;
        top: 8px;
        right: 8px;
      }
    }
  }
}
</style>
<style lang="scss">
.services-popup {
  .el-dialog__body {
    max-height: 60vh;
    overflow-y: auto;
  }
  .service-card .el-card__body {
    padding: 12px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>

